<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-billing-payment'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Payments</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-billing-payment'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addPayment">Add Payment</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Payment</span>
      <div class="col-wrapper">
        <div class="col">
          <div class="card-wrapper">
            <Card v-model="cardDetail"></Card>
          </div>
        </div>
        <div class="col">
          <div class="primary-input-container">
            <p class="pimary-input-title">Number</p>
            <input
              type="tel"
              v-model="cardDetail.number"
              v-card-focus
              v-validate="'required'"
              name="number"
              placeholder="Card number"
              class="pimary-input"
            />
          </div>
          <div class="primary-input-container">
            <p class="pimary-input-title">Name</p>
            <input
              type="text"
              v-model="cardDetail.name"
              v-card-focus
              v-validate="'required'"
              name="name"
              placeholder="Card number"
              class="pimary-input"
            />
          </div>
          <div class="primary-input-container">
            <p class="pimary-input-title">Expiry</p>
            <input
              type="tel"
              v-model="cardDetail.expiry"
              v-card-focus
              v-validate="'required'"
              name="expiry"
              placeholder="Card number"
              class="pimary-input"
            />
          </div>
          <div class="primary-input-container">
            <p class="pimary-input-title">CVC</p>
            <input
              type="number"
              v-model="cardDetail.cvc"
              v-card-focus
              v-validate="'required'"
              name="cvc"
              placeholder="Card number"
              class="pimary-input"
            />
          </div>
          <!-- <form>
            <primary-input type="text"
                           name="number"
                           class="field"
                           v-model="invoice.invoice_start_date"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('')}"
                           placeholder="Enter card number" />
            <div class="help is-danger"
                 v-if="errors.has('')">
              {{ errors.first('') }}
            </div>
            <div class="help is-danger"
                 v-if="paymentError">
              {{paymentError.first_name ? paymentError.first_name[0] : null}}
            </div>
            <primary-input type="text"
                           name="name"
                           v-model="invoice.invoice_end_date"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('')}"
                           placeholder="Enter full name" />
            <div class="help is-danger"
                 v-if="errors.has('firt name')">
              {{ errors.first('') }}
            </div>
            <div class="help is-danger"
                 v-if="paymentError">
              {{paymentError.username ? paymentError.username[0] : null}}
            </div>
            <primary-input type="text"
                           name="expiry"
                           v-model="invoice.amount"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('')}"
                           placeholder="Enter MM/YY" />
            <div class="help is-danger"
                 v-if="errors.has('firt name')">
              {{ errors.first('') }}
            </div>
            <div class="help is-danger"
                 v-if="paymentError">
              {{paymentError.username ? paymentError.username[0] : null}}
            </div>
            <primary-input type="text"
                           name="cvc"
                           v-model="invoice.amount"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('')}"
                           placeholder="Enter CVC" />
            <div class="help is-danger"
                 v-if="errors.has('firt name')">
              {{ errors.first('') }}
            </div>
            <div class="help is-danger"
                 v-if="paymentError">
              {{paymentError.username ? paymentError.username[0] : null}}
            </div>
          </form>-->
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="method"
            class="field"
            v-model="payment.method"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('method')}"
            placeholder="Enter card method"
          />
          <div class="help is-danger" v-if="errors.has('method')">{{ errors.first('method') }}</div>
          <div
            class="help is-danger"
            v-if="paymentError"
          >{{paymentError.method ? paymentError.method[0] : null}}</div>
          <primary-input
            type="text"
            name="amount"
            class="field"
            v-model="payment.amount"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('amount')}"
            placeholder="Enter card amount"
          />
          <div class="help is-danger" v-if="errors.has('amount')">{{ errors.first('amount') }}</div>
          <div
            class="help is-danger"
            v-if="paymentError"
          >{{paymentError.amount ? paymentError.amount[0] : null}}</div>
          <div class="primary-input-container">
            <p class="pimary-input-title">paid on</p>
            <div class="primary-select-wrapper">
              <date-picker
                name="paid on"
                v-model="payment.paid_on"
                v-validate="'required'"
                :class="{'input': true, 'is-danger': errors.has('paid on')}"
                calendar-class="calendar-class"
                format="yyyy-MM-dd"
                wrapper-class="date-wrapper"
                placeholder="DD MM YYYY"
                input-class="date-picker my"
              />
              <img src="../../../assets/Icon/Arrow/Down.svg" class="icon-down" alt />
            </div>
          </div>
          <div class="help is-danger" v-if="errors.has('paid on')">{{ errors.first('paid on') }}</div>
          <div
            class="help is-danger"
            v-if="paymentError"
          >{{paymentError.paid_on ? paymentError.paid_on[0] : null}}</div>
          <primary-select
            type="text"
            name="invoice list"
            v-validate="'required'"
            v-model="payment.invoice_uuid"
            :class="{'input': true, 'is-danger': errors.has('invoice list')}"
            placeholder="Invoice Id"
          >
            <option v-for="(i, k) in invoices" :value="i.invoiceId" :key="k">{{i.invoiceNumber}}</option>
          </primary-select>
          <!-- <div class="list primary-input-container">
              <p class="pimary-input-title">Invoice List</p>
                <multiselect v-model="invoice.id"
                            :options="invoiceIds"
                            :value="invoiceIds.invoice_uuid"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Invoice List"
                            label="invoice_name"
                            track-by="invoice_uuid"
                            :preselect-first="true">
                  <template slot="selection"
                            slot-scope="{ values, search, isOpen, option }">
                    <span class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen">{{ values.length }} invoice selected
                    </span>
                  </template>
                </multiselect>
          </div>-->
          <div
            class="help is-danger"
            v-if="errors.has('invoice list')"
          >{{ errors.first('invoice list') }}</div>
          <div
            class="help is-danger"
            v-if="paymentError"
          >{{paymentError.invoice_list ? paymentError.invoice_list : null}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    Card: () => import("@/components/Card.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    DatePicker: () => import("vuejs-datepicker"),
  },
  data: () => ({
    contactError: null,
    cardDetail: {
      number: "",
      name: "",
      expiry: "",
      cvc: "",
    },
    paymentError: null,
    payment: {
      card_number: "",
      card_name: "",
      expiry_date: "",
      cvv: "",
      amount: "",
      method: "",
      paid_on: "",
      invoice_uuid: "",
    },
    invoice: {
      invoice_end_date: null,
      invoice_start_date: null,
      // attachment_file_uuid: null,
      amount: null,
      company_uuid: null,
    },
    invoices: [],
    all_date: "",
  }),
  created() {
    this.GetInvoiceList();
    // var card = new Card({
    //     // a selector or DOM element for the form where users will
    //     // be entering their information
    //     form: 'form', // *required*
    //     // a selector or DOM element for the container
    //     // where you want the card to appear
    //     container: '.card-wrapper', // *required*

    //     formSelectors: {
    //         numberInput: 'input#number', // optional — default input[name="number"]
    //         expiryInput: 'input#expiry', // optional — default input[name="expiry"]
    //         cvcInput: 'input#cvc', // optional — default input[name="cvc"]
    //         nameInput: 'input#name' // optional - defaults input[name="name"]
    //     },

    //     width: 200, // optional — default 350px
    //     formatting: true, // optional - default true

    //     // Strings for translation - optional
    //     messages: {
    //         validDate: 'valid\ndate', // optional - default 'valid\nthru'
    //         monthYear: 'mm/yyyy', // optional - default 'month/year'
    //     },

    //     // Default placeholders for rendered fields - optional
    //     placeholders: {
    //         number: '•••• •••• •••• ••••',
    //         name: 'Full Name',
    //         expiry: '••/••',
    //         cvc: '•••'
    //     },

    //     masks: {
    //         cardNumber: '•' // optional - mask card number
    //     },

    //     // if true, will log helpful messages for setting up Card
    //     debug: false // optional - default false
    // });
    // console.log("card------>",card)
  },
  methods: {
    GetInvoiceList(search, page) {
      this.$store
        .dispatch("GetInvoiceList", {
          search: "",
          page: "",
          paid: false,
        })
        .then((res) => {
          // console.log("resssssssssssssssssss from invoices", res)
          this.invoices = res.items.map(this.transformInvoices);
        });
    },
    transformInvoices(i, k) {
      return {
        invoiceId: i.invoice_uuid,
        invoiceNumber: i.invoice_number,
      };
    },
    addPayment: async function () {
      const valid = await this.$validator.validate();
      if (!valid) {
        return;
      }

      this.payment.card_number = this.cardDetail.number;
      this.payment.card_name = this.cardDetail.name;
      this.payment.cvv = this.cardDetail.cvc;
      this.payment.expiry_date = this.cardDetail.expiry;
      (this.payment.paid_on = format(this.payment.paid_on, "YYYY-MM-DD")),
        (this.payment.expiry_date = this.payment.expiry_date
          .replace(/\//g, "")
          .replace(/ /g, ""));

      console.log("this.payment", this.payment);

      this.$store
        .dispatch("AddPayment", {
          payment: this.payment,
        })
        .then(() => {
          this.$snotify.success("Payment have beed done.", {
            timeout: 6000,
          });
          this.$router.push({ name: "reseller-billing-payment" });
        })
        .catch((err) => {
          if (err.errors) {
            this.paymentError = err.errors[0].payment
              ? err.errors[0].payment
              : null;
            setTimeout(() => {
              this.paymentError = null;
            }, 6000);
          } else {
            if (err.response.data.error) {
              this.$snotify.error(err.response.data.error.message, {
                timeout: 6000,
              });
            } else {
              this.$snotify.error(err.response.data.errors, {
                timeout: 6000,
              });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss">
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 15px;
        padding-left: 0;
        .primary-input-container {
          width: 100%;
          margin-bottom: 15px;
          .pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
            letter-spacing: 0.21px;
            line-height: 15px;
            margin-bottom: 5px;
            text-transform: uppercase;
          }
          .pimary-input {
            width: 100%;
            height: 40px;
            border: 1px solid #edeef3;
            border-radius: 4px;
            background-color: #ffffff;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            padding-left: 15px;
          }
          input:focus {
            border: 1px solid #51a3f3;
          }
          input::placeholder {
            color: #55616e !important;
            opacity: 1;
          }
          .primary-select-wrapper {
            box-sizing: border-box;
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            height: 40px;
            border: 1px solid #edeef3;
            border-radius: 4px;
            background-color: #ffffff;

            ::placeholder {
              color: #55616e !important;
              opacity: 1;
            }
            .calendar-class {
              width: fit-content !important;
              height: fit-content !important;
              font-family: "Helvetica Neue";
              font-size: 14px;
            }
            .date-wrapper {
              width: 100%;
            }
            .vdp-datepicker {
              div {
                width: 100%;
              }
            }
            .vdp-datepicker .my {
              min-height: 40px;
              width: 100%;
              display: block;
              background: transparent;
              padding-left: 15px;
              font-family: "Helvetica Neue";
              font-size: 14px;
              line-height: 25px;
              border: none;
            }
            select:focus {
              border: 1px solid #51a3f3;
            }
            .icon-down {
              position: absolute;
              left: 100%;
              margin-left: -35px;
            }
          }
        }
      }
    }
  }
}
</style>

